import AGENCIES_PATH from "./private/agencies.module.path";
import LOGOUT_PATH from "./private/logout.module,path";
import MORTGAGE_PATH from "./private/mortgage.module.path";
import OWNER_PATH from "./private/owners.module.path";
import PROFILE_PATH from "./private/profile.module.path";
import PROPERTY_PATH from "./private/property.module.path";
import { PATH_ROUTES_REPORT } from "./private/reports.module.path";
import { PRIVATE_MODULES_PATH } from "./private/root.path";
import TOOLS_PATH from "./private/tools.module.path";
import {
  PATH_ROUTER_USER,
  PATH_ROUTES_USER
} from "./private/user.module.path";
import {
  PATH_ROUTER_AUTH,
  PATH_ROUTES_AUTH
} from "./public/auth.module.path";
import { PUBLIC_MODULES_PATH } from "./public/root.path";

/**
 * Only use to navigate
 * @example navigate(PATH.USER.EDIT(USER_ID));
 * navigate to '/user/edit/10'
 *  */
export const PATH = {
  PRIVATE: {
    ROOT: PRIVATE_MODULES_PATH,
    USER: PATH_ROUTES_USER,
    PROFILE: PROFILE_PATH.ROUTES,
    LOGOUT: PROFILE_PATH.ROUTES,
    TOOLS: TOOLS_PATH.ROUTES,
    OWNERS: OWNER_PATH,
    PROPERTY: PROPERTY_PATH,
    MORTGAGE_REFERENCE: MORTGAGE_PATH.ROUTES,
    REPORT: PATH_ROUTES_REPORT,
    AGENCIES: AGENCIES_PATH
  },
  PUBLIC: {
    ROOT: PUBLIC_MODULES_PATH,
    AUTH: PATH_ROUTES_AUTH
  }
};

/**
 * Only use to *.ROUTER.TSX
 * @example
 *  *👉*
 *  <Routes>
 *     <Route path={`${PATH_ROUTER.USER.LIST}`} element={<UserList />} />
 *  </Routes>
 *
 * *👉 RETURN*
 * <Routes>
 *     <Route path={"/"} element={<UserList />} />
 *   </Routes>
 *  */
export const PATH_ROUTER = {
  PRIVATE: {
    ROOT: PRIVATE_MODULES_PATH,
    USER: PATH_ROUTER_USER,
    PROFILE: PROFILE_PATH.ROUTER,
    LOGOUT: LOGOUT_PATH.ROUTER,
    TOOLS: TOOLS_PATH.ROUTER,
    OWNERS: OWNER_PATH.ROUTER,
    MORTGAGE_REFERENCE: MORTGAGE_PATH.ROUTER,
    PROPERTY: PROPERTY_PATH.ROUTER
  },
  PUBLIC: {
    ROOT: PUBLIC_MODULES_PATH,
    AUTH: PATH_ROUTER_AUTH
  }
};
